import { FloraProvider, Heading, globalCss } from '@grupoboticario/flora-react'
import { BoxMain, BoxDescription, ContainerLogo, Image } from './Styled'
import { Flex } from '@grupoboticario/flora-react'
import { floraTheme } from './floraTheme'
const globalStyles = globalCss({
  body: {
    margin: 0,
    padding: 0,
  },
})

export default function Maintenance() {
  globalStyles()
  return (
    <FloraProvider theme={floraTheme((process.env.REACT_APP_CURRENT_BRAND || '')?.toString())}>
      <Flex>
        <ContainerLogo>
          <Image
            tabIndex={0}
            src={process.env.REACT_APP_IMAGE_WHITE_LOGO}
            alt={process.env.REACT_APP_BRAND_TEXT}
            width={125}
          />
        </ContainerLogo>
      </Flex>
      <BoxMain>
        <Heading
          level={6}
          as="h1"
          css={{
            fontWeight: '$medium',
            lineHeight: '$normal',
            textAlign: 'center',
            marginTop: '$9',
          }}
        >
          Estamos em manutenção
        </Heading>
        <BoxDescription>
          O site está em manutenção temporária para melhorias. Por favor, tente novamente mais tarde
        </BoxDescription>
      </BoxMain>
    </FloraProvider>
  )
}
